import axios from 'axios';
import React, { useRef } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';

interface IdentityVerificationModalProps {
    isOpen: boolean;
    onClose: () => void;
}

interface IFormData {
    name: string;
    phonePart1: string;
    phonePart2: string;
    phonePart3: string;
    birthDate: string;
    gender: string;
    carrier: string;
}


const IdentityVerificationModal: React.FC<IdentityVerificationModalProps> = ({ isOpen, onClose }) => {
    const { register, handleSubmit, formState: { errors }, setValue, trigger } = useForm<IFormData>({
        defaultValues: {
            name: '',
            birthDate: '',
            phonePart1: '',
            phonePart2: '',
            phonePart3: '',
            gender: '',
            carrier: ''
        }
    });
    
    const phonePart1Ref = useRef<HTMLInputElement>(null);
    const phonePart2Ref = useRef<HTMLInputElement>(null);
    const phonePart3Ref = useRef<HTMLInputElement>(null);
    
    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let filteredValue = value.replace(/[^0-9]/g, '');
        if (name === 'phonePart1') {
          filteredValue = filteredValue.slice(0, 3);
        } else if (name === 'phonePart2' || name === 'phonePart3') {
          filteredValue = filteredValue.slice(0, 4);
        }
    
        setValue(name as keyof IFormData, filteredValue);
        trigger(name as keyof IFormData);
    
        if (name === 'phonePart1' && filteredValue.length === 3) {
          phonePart2Ref.current?.focus();
        } else if (name === 'phonePart2' && filteredValue.length === 4) {
          phonePart3Ref.current?.focus();
        }
      };
    
      const handlePhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const { name, value, selectionStart } = e.currentTarget;
    
        if (e.key === 'Backspace' && selectionStart === 0 && value === '') {
          e.preventDefault();
    
          if (name === 'phonePart3') {
            phonePart2Ref.current?.focus();
          } else if (name === 'phonePart2') {
            phonePart1Ref.current?.focus();
          }
        }
      };
    
    const onSubmit: SubmitHandler<IFormData> = async (data) => {
        try {
            // const response = await axios.post('/api/users/verify', data);
            const fullPhoneNumber = `${data.phonePart1}-${data.phonePart2}-${data.phonePart3}`;
            const birthDate = data.birthDate.replace(/\//g, "");    
            console.log(data, fullPhoneNumber, birthDate);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="identityVerificationModal">
            <div className="identityVerificationModal__overlay">
                <div className="identityVerificationModal__content">
                    <button onClick={onClose} className="close-btn">X</button>
                    <h3>본인 확인</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                            <label htmlFor="name">이름</label>
                            <input type="text" id="name" {...register("name", { required: "이름은 필수 항목입니다." })} />
                            {errors.name && <p className="error-message">{errors.name.message}</p>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="phonePart1">휴대폰 번호</label>
                            <div className="phone-input-group">
                            <input type="text" id="phonePart1" maxLength={3} {...register("phonePart1", { required: "휴대폰 번호는 필수 항목입니다.", maxLength: 3, minLength: 3 })} onChange={handlePhoneChange} onKeyDown={handlePhoneKeyDown} ref={phonePart1Ref} />
                            <span>-</span>
                            <input type="text" id="phonePart2" maxLength={4} {...register("phonePart2", { required: "휴대폰 번호는 필수 항목입니다.", maxLength: 4, minLength: 4 })} onChange={handlePhoneChange} onKeyDown={handlePhoneKeyDown} ref={phonePart2Ref} />
                            <span>-</span>
                            <input type="text" id="phonePart3" maxLength={4} {...register("phonePart3", { required: "휴대폰 번호는 필수 항목입니다.", maxLength: 4, minLength: 4 })} onChange={handlePhoneChange} onKeyDown={handlePhoneKeyDown} ref={phonePart3Ref} />
                            </div>
                            {(errors.phonePart1 || errors.phonePart2 || errors.phonePart3) && <p className="error-message">휴대폰 번호는 필수 항목입니다</p>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="birthDate">생년월일</label>
                            <input
                                type="text"
                                inputMode="numeric" // 모바일에서 숫자 키패드 유도
                                id="birthDate"
                                placeholder="YYYY/MM/DD"
                                {...register("birthDate", {
                                required: "생년월일은 필수 항목입니다.",
                                onChange: (e) => {
                                    let value = e.target.value.replace(/\D/g, ""); // 숫자만 남기기

                                    if (value.length > 4 && value.length <= 6) {
                                    value = value.slice(0, 4) + "/" + value.slice(4);
                                    } else if (value.length > 6) {
                                    value =
                                        value.slice(0, 4) +
                                        "/" +
                                        value.slice(4, 6) +
                                        "/" +
                                        value.slice(6, 8);
                                    }
                                    e.target.value = value;
                                },
                                validate: (value) => {
                                    // YYYY/MM/DD 형식 체크
                                    const regex = /^\d{4}\/\d{2}\/\d{2}$/;
                                    if (!regex.test(value)) {
                                    return "형식이 올바르지 않습니다. YYYY/MM/DD 로 입력해주세요.";
                                    }

                                    const [year, month, day] = value.split("/").map(Number);
                                    const date = new Date(year, month - 1, day);

                                    // 날짜 존재 여부 체크
                                    if (
                                    date.getFullYear() !== year ||
                                    date.getMonth() + 1 !== month ||
                                    date.getDate() !== day
                                    ) {
                                    return "존재하지 않는 날짜입니다.";
                                    }

                                    return true;
                                },
                                })}
                            />
                            {errors.birthDate && (
                                <p className="error-message">{errors.birthDate.message}</p>
                            )}
                            </div>
                        <div className="form-group">
                            <label htmlFor="gender">성별</label>
                            <select id="gender" {...register("gender", { required: "성별은 필수 항목입니다." })}>
                                <option value="male">남자</option>
                                <option value="female">여자</option>
                            </select>
                            {errors.gender && <p className="error-message">{errors.gender.message}</p>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="carrier">통신사</label>
                            <select id="carrier" {...register("carrier", { required: "통신사를 선택해주세요." })}>
                                <option value="0">KT</option>
                                <option value="1">LG</option>
                                <option value="2">SKT</option>
                            </select>
                            {errors.carrier && <p className="error-message">{errors.carrier.message}</p>}
                        </div>
                        <div className="form-group">
                            {/* <label htmlFor="verificationCode">인증번호</label>
                            <input type="text" placeholder="인증번호" /> */}
                            <button type="submit">인증번호 전송</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default IdentityVerificationModal;